import GraphQLClient from './../GraphQLClient';
import getPetBreedsQuery from '../query/getPetBreeds.query';

export default class BreedApiService {
  constructor(apiUrl, apiKey) {
    this.graphQLClient = new GraphQLClient(apiUrl, apiKey);
  }

  async getPetBreeds() {
    const data = await this.graphQLClient.query(getPetBreedsQuery);
    return data?.getPetBreeds || [];
  }
}